module.exports = __webpack_public_path__ + "static/media/0324_IMG_LES_ENSEIGNES_LE_CHARCUTIER_SCRABBLE.080777ae.png";